export default "__VITE_ASSET__DaACJ6r___"